import { useMemo } from 'react';
import { useOrientationModulesQuery, useStudentInfoQuery } from '@lingoda/monolith-graphql';

export const useOrientationClassAvailable = () => {
    const { data: studentData, loading: studentInfoLoading } = useStudentInfoQuery();

    const curriculumId = studentData?.student.curriculum.id;
    const sectionName = studentData?.student.section.name;
    const moduleCode = studentData?.student.currentStudentModule.code;

    const canQueryOrientationModules = !!curriculumId && !!sectionName && !studentInfoLoading;
    const variables = useMemo(
        () =>
            canQueryOrientationModules
                ? { sectionName: sectionName, curriculumId: curriculumId }
                : undefined,
        [canQueryOrientationModules, sectionName, curriculumId],
    );

    const { data: orientationModulesData, loading: orientationModulesLoading } =
        useOrientationModulesQuery({
            skip: !canQueryOrientationModules,
            variables,
        });

    const orientationModules = orientationModulesData?.orientationModules ?? [];

    const isOrientationClassAvailable =
        canQueryOrientationModules && !orientationModulesLoading
            ? !!moduleCode && orientationModules.includes(moduleCode)
            : undefined;

    const loading = studentInfoLoading || (canQueryOrientationModules && orientationModulesLoading);

    return { loading, isOrientationClassAvailable };
};
